// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__i43cs","amount":"Amount_amount__3wlcV","tip":"Amount_tip__3hXZ2","tipHeader":"Amount_tipHeader__3QxWo","tipsWrap":"Amount_tipsWrap__38syv"};